export default __webpack_public_path__ + "static/media/ic-close-circle.e3f4801b.svg";